import { render, staticRenderFns } from "./AdminAnnouncement.html?vue&type=template&id=3e3def86&scoped=true&external"
import script from "./AdminAnnouncement.vue?vue&type=script&lang=js"
export * from "./AdminAnnouncement.vue?vue&type=script&lang=js"
import style0 from "./AdminAnnouncement.scss?vue&type=style&index=0&id=3e3def86&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e3def86",
  null
  
)

export default component.exports